import { useState } from "react";
import "./Faqs.css";

const faqs = [
  {
    question: "Do I need any technical skills to use BusinessBay?",
    answer:
      " No technical skills are required; our platform is user-friendly, setup is simple, and it's ready to go",
  },
  {
    question: "How quickly can I start using BusinessBay?",
    answer:
      " Sign up, choose a plan, or talk to our team; start within minutes.",
  },
  {
    question: "Can I use only one feature, like the NFC card?",
    answer:
      "Yes, pick any single feature or combine tools; BusinessBay is flexible for your needs.",
  },
  {
    question: "Are there contracts or long-term commitments?",
    answer:
      "No lock-ins; enjoy complete flexibility to upgrade, downgrade, or cancel anytime.",
  },
  {
    question: " Does BusinessBay work for non-food businesses?",
    answer:
      " Absolutely, from retail to services and real estate, BusinessBay supports any business type.",
  },
  {
    question: "What payment methods can I use?",
    answer:
      " We accept UPI, credit cards, debit cards, and net banking for easy payments.",
  },
  {
    question: "Still have questions?",
    answer:
      " Connect with our 24/7 support team; we’re ready to assist anytime.",
  },
];

export default function Faqs() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section mainclass">
      <div className="maxwidth">
        <p className="faq-label">FAQ</p>
        <h2 className="faq-heading heading">
          Have questions? 
          <br />
          We’ve got you covered.
        </h2>

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${openIndex === index ? "open" : ""}`}
            >
              <button className="faq-question" onClick={() => toggle(index)}>
                <span>{faq.question}</span>
                <span className="faq-icon">▾</span>
              </button>
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
